<template>
  <div class="doc-word">
    <bcc-select v-model="currentVersion" style="float: right; line-height: normal;">
      <bcc-option
        v-for="item in versionOptions"
        :key="item.version"
        :label="item.version"
        :value="item.version"
      >
      </bcc-option>
    </bcc-select>
    <div v-html="currentVersionHtml"></div>
  </div>
</template>

<script>
export default {
  name: 'DocWord',
  props: {
    trackId: String,
    versionOptions: [],
  },
  data() {
    return {
      currentVersion: this.versionOptions[0].version,
    }
  },
  computed: {
    currentVersionHtml() {
      const hitOption = this.versionOptions.find(
        (item) => item.version === this.currentVersion
      )

      return hitOption.html
    },
  },
  mounted() {
    this.$LogReport.sendCustomEvent(this.trackId)
  },
}
</script>

<style scoped lang="scss">
.doc-word {
  word-wrap: break-word;
  max-width: 1200px;
  padding: 2em;
  margin: 0 auto;
  line-height: 2;
  color: #000;
}
</style>
